import { ThemeText } from "@/components/Theme/ThemeText";

export function paragraphParser(node, children, parent, styles) {
    
    //Check if node.children has sourceType anker
    const hasAnker = node.children.some(
        child => child.sourceType === 'anker' 
        || child?.children?.some(grandChild => grandChild.sourceType === 'anker')
    );

    const mb = hasAnker ? 0 : 15;

    return (
        <ThemeText key={node.key} mb={mb}>
            {children}
        </ThemeText>
    )
}